<span [hidden]="!isLoading" class="text-xs-center d-flex flex-column align-items-center">
  <i class="fas fa-cog fa-spin"></i> <span class="mt-2" *ngIf="message">{{ message }}</span>
</span>
